import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const TagGroupPermissionGate = (props: Omit<BasePermissionGateProps<"tag">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="tag"
		/>
	)
}

export default TagGroupPermissionGate
